import { defineMessage } from 'services/localization';

export const messages = {
    previewTextFull: defineMessage('over_or_equal_to_startn_r_or_equal_to_endnumber'),
    previewTextStart: defineMessage('over_or_equal_to_startnumber'),
    previewTextEnd: defineMessage('under_or_equal_to_endnumber'),
};
